module.exports = __webpack_public_path__ + "static/media/hard-assets-alliance-navigation-background-image.90ef5c46.png";